import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/vevo/mascot_peek.png'


const _hoisted_1 = {
  key: 1,
  class: "pa-3"
}
const _hoisted_2 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_3 = { class: "text-h6 font-weight-bold" }
const _hoisted_4 = { class: "text-caption text-grey" }
const _hoisted_5 = { class: "d-flex align-center mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_7 = {
  key: 0,
  class: "ai-report-content text-body-2"
}
const _hoisted_8 = {
  class: "d-flex flex-column mt-3",
  style: {"gap":"0.5rem"}
}
const _hoisted_9 = { class: "text-caption" }
const _hoisted_10 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_11 = { class: "text-caption" }
const _hoisted_12 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_13 = { class: "text-body-2" }
const _hoisted_14 = { class: "text-caption" }
const _hoisted_15 = {
  key: 1,
  class: "my-2"
}
const _hoisted_16 = { class: "mt-1 text-body-2" }
const _hoisted_17 = {
  class: "d-flex mt-2",
  style: {"gap":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      flat: "",
      app: "",
      dark: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          style: {"position":"absolute"},
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "large",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content","font-size":"14px"} }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" VEVOレポート ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        (_ctx.isFetching)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true),
        (_ctx.detail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.lastName) + " " + _toDisplayString(_ctx.detail.firstName), 1),
                _createVNode(_component_ai_report_status_chip, {
                  status: _ctx.detail.status
                }, null, 8, ["status"])
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.detail.className) + " / " + _toDisplayString(_ctx.detail.ageLabel) + " ・ " + _toDisplayString(_ctx.detail.businessYear) + "年度 " + _toDisplayString(_ctx.detail.monthsLabel) + " 期 ", 1),
              (_ctx.detail.dataCoverageMonths.length < 3)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "warning",
                    variant: "outlined",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 対象月のうち " + _toDisplayString(_ctx.formatCoverage(_ctx.detail.dataCoverageMonths)) + " のデータのみで生成されました。 ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card, {
                variant: "outlined",
                class: "pa-4 mt-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "VEVO",
                      class: "mr-1",
                      style: {"width":"24px","height":"24px","object-fit":"contain"}
                    }, null, -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-subtitle-2 font-weight-bold" }, "レポート本文", -1)),
                    _createVNode(_component_v_spacer),
                    (_ctx.detail.content)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.contentLength) + " 文字 ", 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.detail.content)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.detail.content), 1))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "info",
                        variant: "outlined",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" まだ生成されていません。 ", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.detail.status === 'draft')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "primary",
                      variant: "flat",
                      block: "",
                      loading: _ctx.isPublishing,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setStatus('published')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("mdi-publish", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[11] || (_cache[11] = _createTextVNode(" 公開する ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.status === 'published')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "outlined",
                      block: "",
                      loading: _ctx.isPublishing,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStatus('draft')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode("mdi-undo", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createTextVNode(" 下書きに戻す ", -1))
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.status === 'draft')
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 2,
                      disabled: !_ctx.noData,
                      location: "top",
                      text: "対象期間に発達記録がないため再生成できません"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _mergeProps(props, { class: "d-block" }), [
                          _createVNode(_component_v_btn, {
                            variant: "outlined",
                            block: "",
                            disabled: _ctx.noData || _ctx.isRegenerating,
                            onClick: _ctx.openRegenerate
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { start: "" }, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode("mdi-refresh", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[15] || (_cache[15] = _createTextVNode(" 再生成 ", -1))
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ], 16)
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isRegenerating && !_ctx.regenerateOpen)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    variant: "outlined",
                    color: "primary",
                    icon: "mdi-progress-clock",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-body-2 mb-1" }, "再生成中です...", -1)),
                      _createVNode(_component_v_progress_linear, {
                        indeterminate: "",
                        color: "primary",
                        height: "6",
                        rounded: ""
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card, {
                variant: "outlined",
                class: "pa-3 mt-3"
              }, {
                default: _withCtx(() => [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-caption text-grey-darken-2 mb-1 font-weight-bold" }, "操作ログ", -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(" 最終生成: " + _toDisplayString(_ctx.formatDateTime(_ctx.detail.lastGeneratedAt)) + " ", 1),
                    (_ctx.detail.lastGeneratedBy)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " / by " + _toDisplayString(_ctx.detail.lastGeneratedBy), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(" 最終公開: " + _toDisplayString(_ctx.formatDateTime(_ctx.detail.lastPublishedAt)) + " ", 1),
                    (_ctx.detail.lastPublishedBy)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, " / by " + _toDisplayString(_ctx.detail.lastPublishedBy), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (_ctx.detail.status === 'published')
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 2,
                    type: "warning",
                    variant: "outlined",
                    density: "compact",
                    class: "mt-3 text-caption"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode(" 公開済のため、施設Webからの一括再生成ではスキップされます。再生成するには先に「下書きに戻す」を実行してください。 ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.regenerateOpen,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.regenerateOpen) = $event)),
      "max-width": "420",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-subtitle-1 font-weight-bold mb-2" }, "VEVOレポートを再生成", -1)),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.detail ? `${_ctx.detail.lastName} ${_ctx.detail.firstName}` : "") + " さんのレポートを再生成します。 ", 1),
            _createVNode(_component_v_alert, {
              variant: "outlined",
              color: "primary",
              icon: "mdi-information-outline",
              density: "compact",
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.regenerateMode === 'translate')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("現在の本文を選択した言語に翻訳して上書きします。")
                      ], 64))
                    : _createCommentVNode("", true),
                  _cache[19] || (_cache[19] = _createTextVNode(" 非同期処理のため完了まで数十秒〜数分かかります。完了後ステータスは下書きに戻ります。 ", -1))
                ])
              ]),
              _: 1
            }),
            (_ctx.canTranslate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.regenerateMode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regenerateMode) = $event)),
                    class: "mb-1",
                    density: "compact",
                    "hide-details": "",
                    disabled: !!_ctx.activeBatch && _ctx.activeBatch.status === 'processing'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: "単純な再生成",
                        value: "simple"
                      }),
                      _createVNode(_component_v_radio, {
                        label: "翻訳",
                        value: "translate"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  (_ctx.regenerateMode === 'translate')
                    ? (_openBlock(), _createBlock(_component_v_select, {
                        key: 0,
                        modelValue: _ctx.selectedLanguage,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                        items: _ctx.languageItems,
                        "item-title": "label",
                        "item-value": "code",
                        label: "翻訳先の言語",
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        class: "mb-2",
                        disabled: !!_ctx.activeBatch && _ctx.activeBatch.status === 'processing'
                      }, null, 8, ["modelValue", "items", "disabled"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeBatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_v_progress_linear, {
                    indeterminate: _ctx.activeBatch.status === 'processing',
                    "model-value": _ctx.activeBatch.status === 'completed' ? 100 : 0,
                    color: "primary",
                    height: "8",
                    rounded: ""
                  }, null, 8, ["indeterminate", "model-value"]),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.activeBatch.status === 'processing')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("再生成中...")
                        ], 64))
                      : (_ctx.activeBatch.status === 'completed')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              color: "success"
                            }, {
                              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[21] || (_cache[21] = _createTextVNode(" 完了しました。 ", -1))
                          ], 64))
                        : (_ctx.activeBatch.status === 'failed')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "red"
                              }, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createTextVNode("mdi-alert-circle", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[23] || (_cache[23] = _createTextVNode(" 失敗しました。 ", -1))
                            ], 64))
                          : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.closeRegenerate,
                disabled: _ctx.isStarting
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.activeBatch && _ctx.activeBatch.status === "completed" ? "閉じる" : "キャンセル"), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              (!_ctx.activeBatch || _ctx.activeBatch.status === 'failed')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "primary",
                    variant: "flat",
                    loading: _ctx.isStarting,
                    disabled: _ctx.startRegenerateDisabled,
                    onClick: _ctx.startRegenerate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.regenerateMode === "translate" ? "翻訳" : "開始"), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}